import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { scrollToSection } from "../lib/scroll";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 py-12" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <button
            data-testid="footer-logo"
            onClick={() => scrollToSection("#hero")}
            aria-label="AZORUniqueHome — início"
            className="transition-opacity hover:opacity-80"
          >
            <img src="/logo.svg" alt="AZORUniqueHome" className="h-7 w-auto" />
          </button>
          <p className="mt-2 font-mono text-[11px] tracking-widest text-sand/40">
            {t.footer.architectureBy} — UAID Arquitetos
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:text-right">
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-widest text-sand/40 transition-colors hover:text-terracotta sm:justify-end"
          >
            <Lock size={11} />
            {t.footer.admin}
          </Link>
          <p className="font-mono text-[11px] tracking-widest text-sand/40">
            © {year} AZORUniqueHome, Unipessoal LDA · {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
